import { credentialsEpics } from './credentials/credentials.epics';
import { codeDataEpics } from './codeData/codeData.epics';

export default [...credentialsEpics, ...codeDataEpics];
